/* storybook-check-ignore */
import { Box } from '@opendoor/bricks-next';
import { Divider } from '@opendoor/bricks/core';

import { PropertyDetailsFragment } from '__generated__/athena';

import { BuyWithConfidence } from '../BuyWithConfidence';
import { HomeDetails } from '../HomeDetails';
import { PriceHistory } from '../PriceHistory';
import { Schools } from '../Schools';

interface PropertyDetailsProps {
  property: PropertyDetailsFragment;
}

// Initial launch is in Dallas. This may change.
// I've opted to hardcode here instead of using a feature flag because we'd have to read a query param
// in the PDP and make a request to Amplitude and that just seems like overkill for now.
const BUY_WITH_CONFIDENCE_MARKETS = ['DALLAS'];

export const PropertyDetails = ({ property }: PropertyDetailsProps) => {
  return (
    <>
      {BUY_WITH_CONFIDENCE_MARKETS.includes(property.market ?? '') && (
        <Box tag="section">
          <BuyWithConfidence />
          <Divider mt={16} mb={16} />
        </Box>
      )}
      <Box tag="section">
        <HomeDetails property={property} />
        <Divider mt={16} mb={16} />
      </Box>
      <Box tag="section">
        <Schools schools={property?.schools} schoolDistricts={property?.schoolDistricts} />
        <Divider mt={16} mb={16} />
      </Box>
      <Box tag="section">
        {property?.listingHistory && <PriceHistory listingHistory={property.listingHistory} />}
        <Divider mt={16} mb={40} />
      </Box>
    </>
  );
};
